import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  //scroll top
  // $('.back-to-top').click(function(event){
  //   $("html,body").animate({scrollTop: 0}, 1000);
  // });

  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.menu-link').click(function(e) {
      $(this).parent().toggleClass('active').siblings().removeClass('active');
  });

  var indexBanner = new Swiper('#indexBanner', {
    effect: 'fade',
    autoplay: {
      delay: 6000,
    },
    loop: true,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  });

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
      $('.dropdown-box').removeClass('active');
    }
  });

  // 導覽列根據所在內頁添加 .active
  const links = document.querySelectorAll('.menu-link');
  const currentPath = window.location.pathname;

  links.forEach((link) => {
    const linkPath = new URL(link.getAttribute("href"), window.location.origin).pathname;

    if(currentPath === linkPath || currentPath.startsWith(linkPath)) {
      link.closest('.header-menu-link').classList.add("active");
    }
  });

  // 產品內頁圖片Swiper－縮圖
  const productImgSwiperThumb = new Swiper('#postInnerThumbnail', {
    loop: false,
    spaceBetween: 12,
    pagination: {
      el: '.swiper-pagination', // 如果有分頁器
      clickable: true,
    },
    slidesPerView: 3, // 每次顯示4張縮圖
    watchSlidesProgress: true,
    freeMode: false,
    direction: 'horizontal',
    breakpoints: {
      640: {
        slidesPerView: 4,
        direction: 'vertical', // 800px 以下改為水平
      },
    },
  });

  // 產品內頁圖片Swiper－主圖片
  const productImgSwiper = new Swiper('#postInnerBanner', {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next-sm', // 如果有導航按鈕
      prevEl: '.swiper-button-prev-sm',
    },
    pagination: {
      el: '.swiper-pagination', // 如果有分頁器
      clickable: true,
    },
    thumbs: {
      swiper: productImgSwiperThumb,
    }
  });

  // 產品內頁 tabs 顯示切換
  const productTabs = $('.product-detail .tab');
  const productDetails = $('.product-detail .detail-content');

  productTabs.on('click', function(){
    let dataTab = $(this).attr("data-tab");

    initDetailShow();
    $(this).addClass('active');
    productDetails.each(function(){
      if($(this).attr("data-detail") === dataTab) {
        $($(this)).removeClass('hidden');
      }
    })
  });

  function initDetailShow() {
    productTabs.removeClass('active');
    productDetails.addClass('hidden');
  }

  // 產品內頁下拉選單-按鈕
  $('.dropdown-box').on('click', function(event) {
    event.stopPropagation(); // 阻止事件冒泡，避免觸發 document 的點擊事件

    $('.dropdown-box').addClass('active');

    let dropdownList = $(this).siblings('.dropdown-list');
    $('.dropdown-list').not(dropdownList).addClass('hidden'); // 只對其他列表添加 hidden

    if (dropdownList.hasClass('hidden')) {
     dropdownList.removeClass('hidden');
    }
  })

  // 產品內頁下拉選單-清單填入選取項資料
  $('.dropdown-item').on('click', function(){
    if ($(this).attr("data-disabled") === 'true') {
      return; // 禁止選取預設文字選項
    }

    let dropdownText = $(this).closest('.dropdown-list').siblings('.dropdown-box').children('.dropdown-text');
    dropdownText.text($(this).text());

    $(this).closest('.dropdown-list').addClass('hidden');
    $('.dropdown-box').removeClass('active');
  })

  $(document).on('click', function() {
    $('.dropdown-list').not('.hidden').addClass('hidden'); // 只隱藏當前顯示的下拉選單
  });

  // 產品內頁「臨床數據」 如果無內容則隱藏頁籤和該區塊
  const clinicalTab = $('.tab[data-tab="clinical"]');
  const clinicalData = $('.detail-content[data-detail="clinical"]')

  if (clinicalData.length > 0 && clinicalData.html().trim().length === 0) {
    clinicalTab.addClass('hidden');
    clinicalData.addClass('hidden');
  }
});

